require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/freeze.js
 ** module id = 336
 ** module chunks = 0
 **/